/* eslint-disable max-lines-per-function */
import { cn } from "tailwind-variants";

export default function PinningActionBar({
  isCancelDisabled = false,
  isDoneDisabled = false,
  isLoading = false,
  isDesktop = false,
  variant = "absolute",
  onCancel,
  onDone,
  onDoneDisabledClick,
  onEscapeHatchClick,
  ...restProps
}) {
  return (
    <div
      {...restProps}
      className={cn(
        "flex items-center justify-between bg-white p-2 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]",
        variant === "absolute" ? "absolute bottom-0 left-0 right-0 z-10" : "shrink-0",
        restProps.className
      )}
      data-testid="pinning-artboard-actions"
    >
      <div className="flex items-center">
        <button
          className="text-gray-400! hover:text-gray-500! [font-family:inherit]! text-sm! cursor-pointer border-none bg-transparent p-0 font-normal hover:underline"
          type="button"
          data-testid="escape-hatch-button"
          onClick={() => {
            onEscapeHatchClick?.();
          }}
        >
          {" "}
          Use classic edit form{" "}
        </button>
      </div>
      <div className="flex shrink-0 items-center gap-2.5">
        <button
          className="shrink-0 cursor-pointer rounded-[8px] border border-[#414192] bg-white px-3.5 py-2 text-base font-semibold [font-family:inherit] disabled:pointer-events-none disabled:opacity-25"
          type="button"
          style={{ color: "#414192" }}
          disabled={isCancelDisabled}
          data-testid="pinning-cancel"
          onClick={() => {
            onCancel?.();
          }}
        >
          {" "}
          Cancel{" "}
        </button>
        <div className="relative inline-flex">
          <button
            className="shrink-0 cursor-pointer rounded-[8px] border border-[#414192] bg-[#414192] px-3.5 py-2 text-base font-semibold !text-white [font-family:inherit] disabled:pointer-events-none disabled:opacity-25"
            type="button"
            disabled={isDoneDisabled}
            data-testid="pinning-done"
            onClick={() => {
              onDone?.();
            }}
          >
            {isLoading ? "Completing..." : "Done"}
          </button>
          {isDoneDisabled ? (
            <button
              className="absolute inset-0 z-10 h-full w-full cursor-pointer border-none bg-transparent opacity-0"
              type="button"
              aria-label="Button is disabled because of an unfinished pin"
              data-testid="pinning-done-disabled-overlay"
              onClick={() => {
                onDoneDisabledClick?.();
              }}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}
